import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Splide from "@splidejs/splide";
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

gsap.registerPlugin(ScrollTrigger);

export default class{
    constructor(){
        this.run(document);
    }
    run(d){
        const historySlider = d.querySelector('[data-history-slider]');
        if (historySlider) {
            const splide = new Splide(historySlider,{
                autoplay: true,
                type: 'fade',
                rewind: true,
                gap: 20,
                destroy: false,
                arrows: false,
                pagination: false,
                interval: 4000,
                speed: 1000,
                drag: false,
            } ).mount();
        }

        const companySlider = d.querySelector("[data-company-slider]");
        if(companySlider) {
            const splide = new Splide('[data-company-slider]', {
                type: 'loop',
                autoWidth: true,
                pagination: false,
                drag: false,
                arrows: false,
                gap: 0,
                autoScroll: {
                    speed: 1, 
                    pauseOnHover: false, 
                    autoStart: true,
                },
            }).mount({AutoScroll});
        }
    }
}